import { useEffect } from "react";
import { useSeo } from "@/lib/seo";
import { fitTitle, fitDescription } from "@/lib/seoCity";
import PAGES from "@/lib/seoPages.json";

const DESC = Object.fromEntries(PAGES.filter((p) => p.route).map((p) => [p.route, p.description]));

export const useDocTitle = (title, description) => {
  const path = window.location.pathname;
  const desc = description || DESC[path];
  useSeo({ title: fitTitle(title.replace(/ · Aurora-ADV$/i, "")), description: desc && fitDescription(desc), path });
  useEffect(() => { window.scrollTo(0, 0); }, []);
};
